export const TEXT={
    Login:{
        en:"Login",
        ar:"تسجيل الدخول"
    },
    Register:{
        en:"Register",
        ar:"تسجيل"
    },
    EmailAddress:{
        en:"Email Address",
        ar:"البريد الالكتروني"
    },
    Password:{
        en:"Password",
        ar:"كلمة المرور"
    },
    ConfirmPassword:{
        en:"Confirm Password",
        ar:"تأكيد كلمة المرور"
    },
    FirstName:{
        en:"First Name",
        ar:"الاسم الاول"
    },
    LastName:{
        en:"Last Name",
        ar:"الاسم الاخير"
    },
    DontHaveAccount:{
        en:"Don't have an account?",
        ar:"ليس لديك حساب؟"
    },
    RememberMe:{
        en:"Remember me",
        ar:"تذكر بياناتي"
    },
    ForgetPassword:{
        en:"Forget Password",
        ar:"نسيت كلمة المرور"
    },
    Registration:{
        en:"Registration",
        ar:"تسجيل"
    },
    Registed:{
        en:"Registed",
        ar:"المسجلين"
    },
    Sessions:{en:"Sessions",ar:"الجلسات"},
    Volanteering:{en:"Volanteering",ar:"التطوع"},
    Returning:{en:"Returning",ar:"اللي راجعين"},
    Missing:{en:"Missing",ar:"اللي مش موجودين"},
    Name:{en:"Name",ar:"الاسم"},
    Class:{en:"Class",ar:"الصف"},
    Address:{en:"Address",ar:"العنوان"},
    Import:{en:"Import database",ar:"استيراد البيانات"},
    Export:{en:"Export database",ar:"توريد البيانات"},
    CreateDB:{en:"Create database",ar:"انشاء قاعدة بيانات"},
    CreateDbGroup:{en:"Create database group",ar:"انشاء مجموعة لقواعد البيانات"},
    DbBrowser:{en:"Database Browser",ar:"متصفح قواعد البيانات"},
    Dashboard:{en:"Dashboard",ar:"لوحة المعلومات"},
    YourDashboards:{en:"Your Dashboards",ar:"لوحات المعلومات الخاصة بك"},
    Loading:{en:"Loading...",ar:"جاري التحميل..."},
    Version:{en:"Version",ar:"الإصدار"},
    Databases:{en:"Databases",ar:"قواعد البيانات"},
    ClickToViewDashboard:{en:"Click to view dashboard",ar:"انقر لعرض لوحة المعلومات"},
    QuickActions:{en:"Quick Actions",ar:"الإجراءات السريعة"},
}
export default TEXT;  